const SELLER_TYPE = {
  PRIVATE: 'PRIVATE',
  BUSINESS: 'BUSINESS',
  TRADER: 'TRADER',
};

export {SELLER_TYPE};
